import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const TestimonialsSection = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [title, setTitle] = useState('A VOZ DE NOSSOS CLIENTES');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            const contentDoc = await getDoc(doc(db, "siteContent", "main"));
            if (contentDoc.exists()) {
                setTitle(contentDoc.data().testimonialsTitle || 'A VOZ DE NOSSOS CLIENTES');
            }

            const querySnapshot = await getDocs(collection(db, "testimonials"));
            setTestimonials(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setIsLoading(false);
        };
        fetchContent();
    }, []);

    return (
        <section id="depoimentos" className="py-20 md:py-32 bg-background/50">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary">{title}</h2>
                {isLoading ? (
                    <p className="text-center">Carregando depoimentos...</p>
                ) : (
                    <div className="grid md:grid-cols-3 gap-8">
                        {testimonials.map((testimonial) => (
                            <div key={testimonial.id} className="bg-neutral-900 p-8 rounded-lg border border-neutral-700/50">
                                <p className="text-text/80 italic mb-4">"{testimonial.quote}"</p>
                                <p className="font-bold text-primary text-right">- {testimonial.name}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default TestimonialsSection;
